import { InfoMessage as InfoMessageDefault } from './InfoMessage'
import { InfoMessageCollapse } from './InfoMessageCollapse'

export * from './InfoMessage'
export * from './InfoMessage.types'
export * from './InfoMessage.styles'

const InfoMessageComponent = { Default: InfoMessageDefault, Collapse: InfoMessageCollapse }

export { InfoMessageComponent }
